import Api from "./Api";

async function editBill(token,data,cancelToken){
    const response=await Api.put('/api/v1/Providers/Bills',data,{headers: {"Authorization": `Bearer ${token}`},cancelToken});

    return response;
}
export default editBill;